module.exports = __webpack_public_path__ + "img/cv.6c8049de.svg";